import moment from 'moment-timezone'

export const defaultDateFormat = 'YYYY-MM-DD HH:mm'

export const format = (date, timezone, dateFormat = defaultDateFormat) => {
	if (timezone) {
		const timezoneFormat = dateFormat + ' (z)'
		return moment(date).tz(timezone).format(timezoneFormat)
	}
	return moment(date).format(dateFormat)
}

export const unaryFormat = date => moment(date).format(defaultDateFormat)

export const today = () => moment().format(defaultDateFormat)

export const startOfDay = () =>
	moment().startOf('day').format(defaultDateFormat)

export const endOfDay = () => moment().endOf('day').format(defaultDateFormat)

export const toDate = date => {
	const result = moment(date)
	return result.isValid() ? result.toDate() : null
}

export const DateUtilPlugin = {
	install(Vue) {
		Vue.prototype.$dateUtils = {
			format,
			unaryFormat,
			today,
			startOfDay,
			endOfDay,
			toDate,
			defaultDateFormat
		}
	}
}
